import React from 'react';
import NumberFormattedFormTextField from "components/Common/Inputs/FormControls/NumberFormattedFormTextField.js";

export const PhoneNumberMask = ['(', /[2-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

export default class FormPhoneNumberField extends React.Component {
    render() {
        return (
            <NumberFormattedFormTextField
                {...this.props}
                mask={PhoneNumberMask}/>
        );
    }
}
